document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ Accordion script initialized");

  const accordions = document.querySelectorAll(".accordion-block");
  console.log(`Found ${accordions.length} accordion block(s)`);

  accordions.forEach((accordion, aIndex) => {
    const allowMultiple = accordion.dataset.allowMultiple === "true";
    console.log(
      `Accordion[${aIndex}] allowMultiple =`,
      allowMultiple,
      accordion
    );

    accordion
      .querySelectorAll(".accordion-toggle")
      .forEach((toggle, tIndex) => {
        toggle.addEventListener("click", () => {
          console.log(`▶️ Toggle clicked [${aIndex}:${tIndex}]`);
          const item = toggle.closest(".accordion-item");
          const content = item.querySelector(".accordion-content");
          const isOpen = item.classList.contains("is-open");

          console.log("Current item:", item);
          console.log("Is open?", isOpen);

          // Close other items if not allowing multiple
          if (!allowMultiple) {
            accordion
              .querySelectorAll(".accordion-item.is-open")
              .forEach((open) => {
                if (open !== item) {
                  console.log("🔻 Closing other open item:", open);
                  open.classList.remove("is-open");
                  collapse(open.querySelector(".accordion-content"));
                  open
                    .querySelector(".accordion-toggle")
                    .setAttribute("aria-expanded", "false");
                }
              });
          }

          // Toggle the clicked item
          if (isOpen) {
            console.log("🔒 Collapsing item");
            item.classList.remove("is-open");
            collapse(content);
            toggle.setAttribute("aria-expanded", "false");
          } else {
            console.log("🔓 Expanding item");
            item.classList.add("is-open");
            expand(content);
            toggle.setAttribute("aria-expanded", "true");
          }
        });
      });
  });

  /** Smooth expand */
  function expand(element) {
    console.log("⬇️ expand() start", element);
    element.style.overflow = "hidden";
    element.style.display = "block"; // ensures visibility
    const height = element.scrollHeight;
    element.style.height = "0px";
    requestAnimationFrame(() => {
      element.style.transition = "height 0.3s ease";
      element.style.height = height + "px";
    });
    element.addEventListener(
      "transitionend",
      () => {
        console.log("✅ expand() done");
        element.style.height = "auto";
        element.style.overflow = "visible";
      },
      { once: true }
    );
  }

  /** Smooth collapse */
  function collapse(element) {
    console.log("⬆️ collapse() start", element);
    const height = element.scrollHeight;
    element.style.overflow = "hidden";
    element.style.height = height + "px";
    requestAnimationFrame(() => {
      element.style.transition = "height 0.3s ease";
      element.style.height = "0px";
    });
    element.addEventListener(
      "transitionend",
      () => {
        console.log("✅ collapse() done");
        element.style.display = "none";
      },
      { once: true }
    );
  }
});
